export default __webpack_public_path__ + "static/media/Rectangle.5bcbfb51.svg";